/**
 * 文件说明:
 *
 * hz 初始化hooks
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {useEffect} from 'react'
import {useShallowEqualSelector, useRefData, useSafeState} from 'hooks'
import {router as reactRouter, useDispatch} from 'umi'
import {urlToList, checkPathList, createMemoizeCache} from 'utils'

/**
 * 功能说明：hz init hooks
 * @参数 noInit not init
 * @参数 pathname react router pathname
 */
export function useInit({noInit = false, pathname} = {}) {
    const {accessToken} = useShallowEqualSelector(({base}) => ({
        accessToken: base?.accessToken,
    }))

    const [status, setStatus] = useSafeState(0)

    const dispatch = useDispatch()
    const getRefData = useRefData({noInit, dispatch, pathname, status, setStatus})

    useEffect(() => {
        const fetchInitData = async (refresh = false) => {
            try {
                if (getRefData().status === 3) {
                    return
                }

                if (!refresh && getRefData().status === 1) {
                    return
                }

                getRefData().setStatus(3)

                await Promise.all([
                    getRefData().dispatch({
                        type: 'auth/init',
                        payload: {
                            with_role: 1,
                            with_beginner_guide_enabled: 1,
                        },
                    }),
                    getRefData().dispatch({
                        type: 'menu/current',
                    }),
                ])

                // await getRefData().dispatch({
                //     type: 'auth/agentConfig',
                // })

                getRefData().setStatus(1)
            } catch (e) {
                const responseStatus = e?.response?.status
                if (responseStatus === 401) {
                    getRefData().setStatus(4)
                } else {
                    getRefData().setStatus(2)
                }

                throw e
            }
        }

        if (accessToken) {
            !getRefData().noInit && fetchInitData()
        } else {
            reactRouter.replace('/login')
        }
    }, [pathname])

    return {status}
}

export const checkPagesPermission = createMemoizeCache({
    isEqual(newInputs, lastInputs) {
        return newInputs === lastInputs
    },
    getKey(checkFlatTree, pathname) {
        return pathname
    },
    getDeps(checkFlatTree) {
        return checkFlatTree
    },
    getVal(checkFlatTree, pathname) {
        let pass = false

        if (checkFlatTree?.length) {
            const pathnameList = urlToList(pathname)
            pass =
                checkFlatTree.findIndex((item) => {
                    if (item.isExternal) {
                        return item === pathname
                    }

                    return checkPathList(item.url, pathnameList)
                }) > -1
        }

        return pass
    },
})

/**
 * 功能说明：根据菜单数据检查页面是否有权限
 * @参数 pathname react router pathname
 * @参数 noCheckPermission 本页面不检查权限
 */
export function useCheckPermission({pathname, noCheckPermission = false} = {}) {
    const {checkFlatTree = [], accessToken} = useShallowEqualSelector(({menu, base}) => ({
        checkFlatTree: menu?.checkFlatTree,
        accessToken: base?.accessToken,
    }))

    const getRefData = useRefData({noCheckPermission, checkFlatTree, accessToken})

    useEffect(() => {
        if (!getRefData()?.noCheckPermission && getRefData()?.accessToken) {
            if (checkPagesPermission(getRefData().checkFlatTree, pathname)) {
                return
            }

            reactRouter.replace('/403')
        }
    }, [pathname])
}
